import { Box, type BoxProps, Slide, type SlideProps } from "@mui/material";
import { mergeSxProps } from "@src/appV2/redesign/system/ui-components";

export interface AnimatedStoryWrapperProps extends Omit<BoxProps, "component"> {
  index: number;
  currentIndex: number;
  previousIndex: number;
  onClick?: () => void;
}

export function AnimatedShiftRecommendationsWrapper(props: AnimatedStoryWrapperProps) {
  const { index, currentIndex, previousIndex, sx, children, ...rest } = props;

  const isGoingForward = previousIndex < currentIndex;
  const isCurrentIndex = index === currentIndex;
  const isBeforeCurrentIndex = index < currentIndex;
  let direction: SlideProps["direction"] = "left";

  if (isGoingForward) {
    direction = isBeforeCurrentIndex ? "right" : "left";
  } else {
    direction = isBeforeCurrentIndex || isCurrentIndex ? "right" : "left";
  }

  return (
    <Slide
      mountOnEnter
      unmountOnExit
      appear
      direction={direction}
      in={isCurrentIndex}
      timeout={{
        appear: 500,
        enter: 500,
        exit: 500,
      }}
    >
      <Box
        sx={mergeSxProps(
          {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            height: "100%",
            width: "100%",
          },
          sx
        )}
        {...rest}
      >
        {children}
      </Box>
    </Slide>
  );
}
